module.exports = __webpack_public_path__ + "static/media/project-breaktheyoutube.c48199e7.jpg";